module.exports = __webpack_public_path__ + "static/media/cold-gray.4da7e7b8.svg";